var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.996 9.6H8.001a.8.8 0 0 1-.33-.037c-.106-.035-.204-.092-.287-.168a.8.8 0 0 1-.194-.919.81.81 0 0 1 .194-.269c.082-.075.181-.132.287-.168s.219-.048.33-.037h7.995a.8.8 0 0 1 .88.799.8.8 0 0 1-.88.799zm-3.997 3.202H8.001c-.111.011-.224-.002-.33-.037s-.204-.092-.287-.168-.149-.167-.194-.269a.8.8 0 0 1-.069-.325.79.79 0 0 1 .069-.325.8.8 0 0 1 .811-.474h3.998a.8.8 0 0 1 .88.799.8.8 0 0 1-.55.762c-.106.035-.219.048-.33.037zM2.4 24A2.4 2.4 0 0 1 0 21.6V5.603c0-1.486.59-2.911 1.641-3.962S4.117 0 5.603 0h12.795c1.486 0 2.911.59 3.962 1.641A5.6 5.6 0 0 1 24 5.603V15c0 1.486-.59 2.911-1.641 3.962s-2.476 1.641-3.962 1.641H9a2.39 2.39 0 0 0-1.335.405L3.75 23.595c-.399.268-.87.409-1.35.405zM5.603 1.598a4 4 0 0 0-4.005 4.005V21.6c0 .145.04.287.114.411a.8.8 0 0 0 .309.294c.128.068.271.101.416.094s.285-.052.406-.132l3.908-2.61A3.99 3.99 0 0 1 9 18.983h9.398c1.059.002 2.075-.416 2.826-1.163A4 4 0 0 0 22.403 15V5.603a4 4 0 0 0-3.997-3.997L5.603 1.598z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.70f75333586622713044caaee814925a.svg";
export { ForwardRef as ReactComponent };